import { useParams } from 'react-router-dom';
import { CalendarFrame } from 'components/CalendarTools';


export const RequestCalendarFullPage = () => {
    const { requestKey = "" } = useParams<{ requestKey: string }>();

    console.log("fullpage: requestKey", requestKey);
    return (
        <CalendarFrame
            associated_type="request"
            associated_uuid={requestKey}
            backTo={`/request/${requestKey}`}
        />

    );
};

export default RequestCalendarFullPage;
